import { Injectable } from "@angular/core";
import { TaskIdInfo, Visit } from "../../models";

@Injectable({
    providedIn: "root"
})
export class VisitMapperService {

    constructor() {
    }

    public mapToTaskIdInfo(visits: Visit[], employeeWorkHourId: string): TaskIdInfo[] {
        return visits
            .filter(task => task.workHourId === employeeWorkHourId)
            .map(
                task => <TaskIdInfo>{ taskId: task.taskId, routePlannerTaskId: task.routePlannerTaskId }
            );
    }
}
